"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/WizardFrame.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _steps = require('./steps');








 const WizardHeader = ({ title, subtitle, closeLabel, onClose }) => (
  _react2.default.createElement('div', { className: "broadcast-wizard--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}
    , _react2.default.createElement('div', { className: "broadcast-wizard--head-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}
      , _react2.default.createElement('h1', { className: "broadcast-wizard--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}},  title )
      , _react2.default.createElement('div', { className: "broadcast-wizard--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}},  subtitle )
    )
    , _react2.default.createElement('button', {
      type: "button",
      className: "broadcast-wizard--close",
      'aria-label': closeLabel,
      title: closeLabel,
      onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
    )
  )
); exports.WizardHeader = WizardHeader









 const WizardSteps = ({ current, isEditing, onGotoStep }) => {
  const currentIndex = _steps.stepIndex.call(void 0, current)
  return (
    _react2.default.createElement('nav', { className: "broadcast-wizard--steps", 'aria-label': "Campaign steps" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
      ,  _steps.WIZARD_STEPS.map(({ step, label }, i) => {
        const isCurrent = step === current
        const isDone = !isCurrent && (isEditing || i < currentIndex)
        const className = _classBuilder2.default.call(void 0, 
          'broadcast-wizard--step',
          isCurrent && 'broadcast-wizard--step--current',
          isDone && 'broadcast-wizard--step--done',
        )
        const content = (
          _react2.default.createElement(_react2.default.Fragment, null
            , _react2.default.createElement('span', { className: "broadcast-wizard--step-dot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}} )
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 52}},  label )
          )
        )
        return (
          _react2.default.createElement(_react2.default.Fragment, { key: step, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
            ,  i > 0 && _react2.default.createElement('span', { className: "broadcast-wizard--step-sep", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}} ) 
            ,  isCurrent || !onGotoStep
              ? _react2.default.createElement('span', { className: className, 'aria-current': isCurrent ? 'step' : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}},  content )
              : (
                  _react2.default.createElement('button', { type: "button", className: className, onClick: () => onGotoStep(step), __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
                    ,  content 
                  )
                )
            
          )
        )
      })
    )
  )
}; exports.WizardSteps = WizardSteps

 const WizardBody = ({ isWide, isFill, children }) => (
  _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'broadcast-wizard--body', isFill && 'broadcast-wizard--body--fill'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
    , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'broadcast-wizard--inner', isWide && 'broadcast-wizard--inner--wide'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
      ,  children 
    )
  )
); exports.WizardBody = WizardBody

 const WizardFooter = ({ children }) => (
  _react2.default.createElement('div', { className: "broadcast-wizard--foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}},  children )
); exports.WizardFooter = WizardFooter

 const WizardFooterNote = ({ children }) => (
  _react2.default.createElement(_react2.default.Fragment, null
    , _react2.default.createElement('div', { className: "broadcast-wizard--foot-grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}} )
    , _react2.default.createElement('span', { className: "broadcast-wizard--foot-note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}},  children )
  )
); exports.WizardFooterNote = WizardFooterNote

/* Where a step renders: the create wizard (full pane, sticky footer), in
 * place on the campaign page (F5), below the page's own top section, or in a
 * dialog (Rev 33 T4: a scrolling body and a footer pinned under it). */








const StepFrameContext = _react2.default.createContext({ layout: 'wizard' })

 const StepFrameProvider = StepFrameContext.Provider; exports.StepFrameProvider = StepFrameProvider

 const useStepLayout = () => _react2.default.useContext(StepFrameContext).layout; exports.useStepLayout = useStepLayout

 const StepBody







 = ({ isWide, isFullWidth, isFill, children }) => {
  const { layout, header } = _react2.default.useContext(StepFrameContext)
  if (layout === 'wizard') return _react2.default.createElement(exports.WizardBody, { isWide: isWide, isFill: isFill, __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}},  children )
  if (layout === 'dialog') return _react2.default.createElement('div', { className: "broadcast-message-dialog--scroll", __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}},  header ,  children )
  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'campaign-panel', (isFullWidth || isFill) && 'campaign-panel--full', isFill && 'campaign-panel--fill'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}
      ,  header 
      ,  children 
    )
  )
}; exports.StepBody = StepBody

 const StepFooter = ({ isFullWidth, children }) => {
  const { layout } = _react2.default.useContext(StepFrameContext)
  if (layout === 'wizard') return _react2.default.createElement(exports.WizardFooter, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 131}},  children )
  if (layout === 'dialog') return _react2.default.createElement('div', { className: "broadcast-message-dialog--foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}},  children )
  return _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'campaign-panel', 'campaign-panel--foot', isFullWidth && 'campaign-panel--full'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}},  children )
}; exports.StepFooter = StepFooter
